import { useCompleteUserSignInBonusMutation } from '../../__generated__/graphqlApi';
import { useCallback } from 'react';

const useCompleteUserSignInBonusOperation = () => {
  const [mutate] = useCompleteUserSignInBonusMutation();

  return useCallback(async (): Promise<void> => {
    await mutate({
      variables: {},
    });
  }, [mutate]);
};

export default useCompleteUserSignInBonusOperation;
